import { Component, DestroyRef, inject, OnInit, signal } from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router, RouterOutlet, NavigationEnd } from '@angular/router';
import { NavbarComponent } from '@layouts/sidebar/sidebar.component';
import { LoaderComponent } from '@shared/components/loader.component';
import { LanguageService } from './services/language.service';
import { LoaderService } from './services/loader.service';
import { filter, map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NavbarComponent, LoaderComponent],
  templateUrl: './app.html'
})
export class App implements OnInit {
  protected readonly title = signal('gestion-site');

  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private languageService = inject(LanguageService);
  public loaderService = inject(LoaderService);
  private destroyRef = inject(DestroyRef);

  isLoading = toSignal(this.loaderService.isLoading$, { initialValue: false });

  showLayout = toSignal(
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map((event: NavigationEnd) => !event.url.includes('/unauthorized')),
      startWith(!this.router.url.includes('/unauthorized'))
    ),
    { initialValue: !this.router.url.includes('/unauthorized') }
  );

  ngOnInit() {
    this.route.queryParams
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(params => {
        const lang = params['lang'];
        if (lang) this.languageService.setLanguage(lang);
      });
  }
}
